import { Branch, LocationStatus, UserLocation } from '../../types/location';
import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
export interface LocationState {
  status: LocationStatus | null;
  userLocation: UserLocation | null;
  branch: Branch | null;
}

export interface SetUserLocationPayload {
  userLocation: UserLocation;
}

export interface SetLocationStatusPayload {
  status: LocationStatus | null;
}

export interface SetLocationStatusPayload {
  status: LocationStatus | null;
}

const initialState: LocationState = {
  status: null,
  userLocation: null,
  branch: null,
};

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocationStatus: (state, action: PayloadAction<SetLocationStatusPayload>) => {
      state.status = action.payload.status;
    },
    selectLocationFulfilled: (state, action: PayloadAction<LocationState>) => {
      state.userLocation = action.payload.userLocation;
      state.branch = action.payload.branch;
      state.status = null;
    },
    selectLocationRejected: (state) => {
      state.userLocation = null;
      state.status = null;
    },
  },
});

export const {
  setLocationStatus,
  selectLocationFulfilled,
  selectLocationRejected,
} = locationSlice.actions;

export const setUserLocationEpicAction = createAction<SetUserLocationPayload>(
  'location/setUserLocationEpicAction',
);

export default locationSlice.reducer;
